export const LEADS_TAGS = {
  LEADS_TABLE: "LeadsTable",
} as const;
